import React, { useMemo } from 'react';
import { X } from 'lucide-react';
import okBadge from '../../assets/ok.png';
import firewallBadge from '../../assets/firewall.png';
import './WorkflowEdgePopover.css';

interface WorkflowEdgePopOverProps {
  isOpen: boolean;
  position: { x: number; y: number };
  zIndex: number,
  onClose: (e: React.MouseEvent) => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  hasVulnerability: boolean;
  vulnerabilityCount: number;
  guardrails: string[];
}

const WorkflowEdgePopOver: React.FC<WorkflowEdgePopOverProps> = ({
  isOpen,
  position,
  zIndex,
  onClose,
  onMouseEnter,
  onMouseLeave,
  hasVulnerability,
  guardrails,
}) => {
  
  // Calculate max height based on available space above the badge
  const dynamicStyle = useMemo(() => {
    const padding = 20;
    // Since transform: translate(-50%, -100%) moves it up, 
    // the available height is the badge's Y position minus padding
    const availableHeight = position.y - padding;
    const maxHeight = Math.max(150, Math.min(availableHeight, 400)); // Min 150px, max 400px
    
    return {
      left: position.x,
      top: position.y,
      zIndex,
      maxHeight: `${maxHeight}px`,
    };
  }, [position.x, position.y, zIndex]);

  if (!isOpen) return null;

  return (
    <div
      className="edge-popover"
      style={ dynamicStyle }
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="edge-popover-header">
        <div className="edge-popover-header-left">
          <img
            src={hasVulnerability ? firewallBadge : okBadge}
            alt={hasVulnerability ? "Vulnerabilities" : "OK"}
            className="edge-popover-badge-icon"
          />
          <span className="edge-popover-title">
            {hasVulnerability ? 'Potential vulnerabilities Found' : 'No Vulnerabilities Detected'}
          </span>
        </div>
        <button onClick={onClose} className="edge-popover-close-btn">
          <X size={16} />
        </button>
      </div>

      {hasVulnerability && guardrails.length > 0 && (
        <div className="edge-popover-content">
          <h4 className="edge-popover-section-title">RECOMMENDED GUARDRAILS</h4>
          <p className="edge-popover-description">
            We recommend to add the following DeepKeep guardrails to monitor and prevent run-time violations.
          </p>
          <div className="edge-popover-guardrails">
            {guardrails.map((guardrail, index) => (
              <div key={index} className="edge-popover-guardrail-item">
                {guardrail}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkflowEdgePopOver;